import React from 'react';

const TermsPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last updated: December 15, 2025</p>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using TupleCamp ("the Website"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use our website or purchase our products.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Products and Services</h2>
          <p>TupleCamp provides digital educational content including:</p>
          <ul>
            <li>JavaScript Interview Preparation Kit</li>
            <li>Complete Frontend Interview Preparation Kit</li>
            <li>Frontend Interview Experiences Kit</li>
            <li>Related educational materials and resources</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Digital Product Delivery</h2>
          <p>
            All products are delivered digitally and can be accessed directly on our website within 5-10 minutes of successful payment. Access instructions will be sent to the email address provided during purchase.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Payment Terms</h2>
          <ul>
            <li>All prices are listed in Indian Rupees (&#8377;)</li>
            <li>Payment is processed securely through Cashfree</li>
            <li>We accept UPI, Credit/Debit Cards, Net Banking, and Wallets</li>
            <li>Full payment is required before access to materials is granted</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. No Refund Policy</h2>
          <p className="important-notice">
            <strong>IMPORTANT:</strong> All sales are final. We do not offer refunds under any circumstances.
          </p>
          <p>
            Due to the digital nature of our products and immediate access upon purchase, we maintain a strict no-refund policy. By purchasing our products, you acknowledge and agree that all sales are final and non-refundable.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Intellectual Property</h2>
          <p>
            All content, materials, and products available on TupleCamp are protected by intellectual property laws. You agree to:
          </p>
          <ul>
            <li>Use purchased materials for personal learning only</li>
            <li>Not share, redistribute, or resell any content</li>
            <li>Not copy or reproduce materials for commercial purposes</li>
            <li>Respect all copyright and proprietary notices</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. User Responsibilities</h2>
          <p>You are responsible for:</p>
          <ul>
            <li>Providing accurate information during purchase</li>
            <li>Maintaining the confidentiality of your access credentials</li>
            <li>Ensuring your email address is valid for product delivery</li>
            <li>Safeguarding your account access on our website</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            TupleCamp shall not be liable for any indirect, incidental, special, or consequential damages arising from the use or inability to use our products. Our total liability shall not exceed the amount paid for the specific product in question.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Disclaimer</h2>
          <p>
            Our educational materials are provided "as is" without warranties of any kind. While we strive for accuracy, we do not guarantee specific outcomes, job placements, or interview success. Individual results may vary based on personal effort and circumstances.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Modifications</h2>
          <p>
            We reserve the right to modify these terms at any time. Continued use of our website after changes constitutes acceptance of the modified terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Governing Law</h2>
          <p>
            These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Puducherry, India.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Contact Information</h2>
          <p>For any questions about these Terms and Conditions, please contact us at:</p>
          <ul>
            <li>Email: <a href="mailto:support@tuplecamp.com">support@tuplecamp.com</a></li>
            <li>Instagram: <a href="https://instagram.com/tuplecamp" target="_blank" rel="noopener noreferrer">@tuplecamp</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
